export const MENU_WIDTH = 250;
export const MOBILE_HEADER_HEIGHT = 56;
